import { User } from "@auth0/auth0-react";


const auth0Namespace = "https://arbinsights.com";

/**
 * Mirrors the backend `get_current_admin_user` gate:
 *   1. Auth0 "admin" role present in token
 *   2. Email ends with @arbinsights.com
 */
export function checkUserIsAdmin(user: User): boolean {
	if (!user) return false;
	const roles: string[] = user[auth0Namespace + "/roles"] ?? [];
	if (!roles.includes("admin")) return false;
	return !!(user.email && user.email.endsWith("@arbinsights.com"));
}

/**
 * Mirrors the backend `get_current_superuser` gate:
 *   1. Must pass checkUserIsAdmin
 *   2. Auth0 "superuser" role present in token
 *   (is_superuser DB check is enforced server-side)
 */
export function checkUserIsSuperUser(user: User): boolean {
	if (!checkUserIsAdmin(user)) return false;
	const roles: string[] = user[auth0Namespace + "/roles"] ?? [];
	return roles.includes("superuser");
}
